
import React from "react";
import Btn from "../common/Btn";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import GalleryItem from "../common/GalleryItem";
import { IGallery } from "../../../../../services";
import styles from "../../assets/style.module.css";

export interface GalleryRowProps {
    basePath: string;
    gallery: IGallery[];
}

function GalleryRow({ basePath, gallery }: GalleryRowProps) {

    const labels = i18nManager.Labels.home;

    return (<section className={styles["section-tight"]}>
        <div className={styles["container"]}>
            <h2 className={styles["h1"]}>{labels.gallery_title}</h2>
            <div className={styles["gallery-grid"]}>
                {gallery.map((g) => (<GalleryItem key={g.external_id} gallery={g} />))}
            </div>
            <div className={styles["row-foot"]}>
                <Btn variant="text" to={pagePath(basePath, "GALLERY")}>{labels.view_gallery}</Btn>
            </div>
        </div>
    </section>);
}

export default GalleryRow;
